import React, { useState } from 'react';

const Pagination = ({ currPage, setCurrPage, totalPages, itemsPerPage, setItemsPerPage, totalItem }) => {
    const [input, setInput] = useState("");
    const [showOptions, setShowOptions] = useState(false);

    let startPage = Math.max(currPage - 2, 1);
    let endPage = Math.min(currPage + 2, totalPages);

    // const prevPage = Math.max(currPage - 1, 1);
    const startIdx = ((currPage - 1) * itemsPerPage) + 1;
    const endIdx = (((currPage - 1) * itemsPerPage) + itemsPerPage) > totalItem ? totalItem : (((currPage - 1) * itemsPerPage) + itemsPerPage);

    if (currPage == 1) {
        endPage = Math.min(currPage + 4, totalPages);
    } else if (currPage == 2) {
        endPage = Math.min(currPage + 3, totalPages);
    }

    if (currPage == totalPages) {
        startPage = Math.max(currPage - 4, 1);
    } else if (currPage == totalPages - 1) {
        startPage = Math.max(currPage - 3, 1);
    }
    const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

    const handlePrevPage = () => {
        setCurrPage(curr => Math.max(curr - 1, 1));
    };

    const handleNextPage = () => {
        setCurrPage(curr => Math.min(curr + 1, totalPages));
    };

    const handleInputChange = (e) => {
        setShowOptions(false);
        if (itemsPerPage != e.target.value) {
            setItemsPerPage(parseInt(e.target.value));
            setCurrPage(1)
            setInput(e.target.value);
        } else {
            setInput(e.target.value);
        }

        if (e.target.value == '' && itemsPerPage != 10) {
            setItemsPerPage(10);
            setCurrPage(1);
        }
    }

    const handleOptionClick = (value) => {
        setShowOptions(false);
        if (itemsPerPage != value) {
            setItemsPerPage(value);
            setCurrPage(1)
            setInput(value);
        } else {
            setInput(value);
        }
    };

    const handleDropdownClick = () => {
        setShowOptions(!showOptions);
    };

    return (
        <>
            <div className="pagination">
                <div className='show-page-number'>
                    {totalItem > 0 && <p>Showing {startIdx} to {endIdx} of {totalItem}</p>}
                    {totalItem == 0 && <p>Showing {0} to {0} of {0}</p>}
                    {/* {currPage == 1  && <p>Showing {1} to {totalItem} of {totalItem}</p>} */}
                </div>
                <div className='select-page-number'>
                    <label htmlFor="select-input">Items Per Page</label>
                    <div className="input-container">
                        <input
                            type="number"
                            id="select-input"
                            name="select-input"
                            className='form-control custom-input'
                            placeholder="Enter Items"
                            onChange={handleInputChange}
                            value={input}
                            autoComplete="off"
                        />
                        {/* <div className="dropdown-icon" onClick={handleDropdownClick}>&#9662;</div>
                        {showOptions && (
                            <div className="options-container">
                                {totalItem < 15 && totalItem > 2 && <div className="option" onClick={() => handleOptionClick(2)}>2</div>}
                                {totalItem < 21 && totalItem > 2 && <div className="option" onClick={() => handleOptionClick(3)}>3</div>}
                                {totalItem < 31 && totalItem >= 5 && <div className="option" onClick={() => handleOptionClick(5)}>5</div>}
                                {totalItem < 51 && totalItem >= 7 && <div className="option" onClick={() => handleOptionClick(7)}>7</div>}
                                {totalItem < 82 && totalItem >= 9 && <div className="option" onClick={() => handleOptionClick(9)}>9</div>}
                                {totalItem < 501 && totalItem >= 10 && <div className="option" onClick={() => handleOptionClick(10)}>10</div>}
                                {totalItem < 501 && totalItem >= 101 && <div className="option" onClick={() => handleOptionClick(20)}>20</div>}
                                {totalItem < 501 && totalItem >= 101 && <div className="option" onClick={() => handleOptionClick(30)}>30</div>}
                                {totalItem < 501 && totalItem >= 101 && <div className="option" onClick={() => handleOptionClick(40)}>40</div>}
                                {totalItem < 501 && totalItem >= 101 && <div className="option" onClick={() => handleOptionClick(50)}>50</div>}
                                {totalItem < 1001 && totalItem >= 501 && <div className="option" onClick={() => handleOptionClick(100)}>100</div>}
                                {totalItem < 1001 && totalItem >= 501 && <div className="option" onClick={() => handleOptionClick(200)}>200</div>}
                                {totalItem >= 1001 && <div className="option" onClick={() => handleOptionClick(300)}>300</div>}
                                {totalItem >= 1001 && <div className="option" onClick={() => handleOptionClick(400)}>400</div>}
                                {totalItem >= 1001 && <div className="option" onClick={() => handleOptionClick(500)}>500</div>}
                            </div>
                        )} */}
                    </div>
                </div>

                <div className='page-pagination'>
                    <button className="btn btn-light" type="button" onClick={() => setCurrPage(1)}>First</button>
                    <a disabled={currPage === 1} onClick={handlePrevPage}>&laquo;</a>
                    {pageNumbers.length > 0 && pageNumbers.map(pageNumber => (
                        <a
                            key={pageNumber}
                            onClick={() => setCurrPage(pageNumber)}
                            className={pageNumber == currPage ? "active" : ""}
                        >
                            {pageNumber}
                        </a>
                    ))}

                    {pageNumbers.length == 0 &&
                        <a
                            key={1}
                            onClick={() => setCurrPage(1)}
                            className={1 == currPage ? "active" : ""}
                        >
                            {1}
                        </a>
                    }
                    <a disabled={currPage === totalPages} onClick={handleNextPage}>&raquo;</a>
                    {pageNumbers.length > 0 && <button className="btn btn-light" type="button" onClick={() => setCurrPage(totalPages)}>Last</button>}
                    {pageNumbers.length == 0 && <button className="btn btn-light" type="button" onClick={() => setCurrPage(1)}>Last</button>}
                </div>
            </div>
        </>
    )
}

export default Pagination
